import * as yup from 'yup'

const schema = yup.object().shape({
  title: yup.string().required(),
  subtitle: yup.string(),
  formKind: yup.string().max(200).required(),
  status: yup.string().required().typeError('Selecione um status'),
  radioValue: yup.string(),
})

export default schema
